export const NAVIGATION_MODE_STORAGE_KEY = "navigationMode";
